"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oldPermissionLevelOrder = exports.newPermissionLevelOrder = exports.ProjectMemberType = exports.OldIssuePermissionLevel = exports.NewIssuePermissionLevel = void 0;
let ProjectMemberType = exports.ProjectMemberType = /*#__PURE__*/function (ProjectMemberType) {
  ProjectMemberType["Role"] = "role";
  ProjectMemberType["User"] = "user";
  ProjectMemberType["Company"] = "company";
  return ProjectMemberType;
}({});
let OldIssuePermissionLevel = exports.OldIssuePermissionLevel = /*#__PURE__*/function (OldIssuePermissionLevel) {
  OldIssuePermissionLevel["CreateForMyCompany"] = "create-for-my-company";
  OldIssuePermissionLevel["CreateForOtherCompanies"] = "create-for-other-companies";
  OldIssuePermissionLevel["ManageIssues"] = "manage-issues";
  OldIssuePermissionLevel["ManageMemberPermissions"] = "manage-member-permissions";
  return OldIssuePermissionLevel;
}({});
let NewIssuePermissionLevel = exports.NewIssuePermissionLevel = /*#__PURE__*/function (NewIssuePermissionLevel) {
  NewIssuePermissionLevel["ViewEditAndAssignMyCompany"] = "view-edit-and-assign-my-company";
  NewIssuePermissionLevel["ViewEditAndAssignAll"] = "view-edit-and-assign-all";
  NewIssuePermissionLevel["FullVisibility"] = "full-visibility";
  NewIssuePermissionLevel["ManageIssues"] = "manage-issues";
  NewIssuePermissionLevel["ManageMemberPermissions"] = "manage-member-permissions";
  return NewIssuePermissionLevel;
}({});
const oldPermissionLevelOrder = exports.oldPermissionLevelOrder = {
  [OldIssuePermissionLevel.CreateForMyCompany]: 1,
  [OldIssuePermissionLevel.CreateForOtherCompanies]: 2,
  [OldIssuePermissionLevel.ManageIssues]: 3,
  [OldIssuePermissionLevel.ManageMemberPermissions]: 4
};
const newPermissionLevelOrder = exports.newPermissionLevelOrder = {
  [NewIssuePermissionLevel.ViewEditAndAssignMyCompany]: 1,
  [NewIssuePermissionLevel.ViewEditAndAssignAll]: 2,
  [NewIssuePermissionLevel.FullVisibility]: 3,
  [NewIssuePermissionLevel.ManageIssues]: 4,
  [NewIssuePermissionLevel.ManageMemberPermissions]: 5
};
//# sourceMappingURL=IssuePermission.js.map